export const PERSONAL = 'personal';
export const BUSINESS = 'business';
